import React from 'react'
import { Button, Card, Col, Flex, Row, Form, Typography, Image, Divider, Checkbox } from 'antd'
import {MyInput } from '../../components'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
const { Text, Title } = Typography
const Changepassword = () => {
    
    const [form] = Form.useForm();
  return (
    <div className='padding padding-main'>
        <div className='container'>    
            <Row justify={'center'}>
                <Col lg={{span: 12}} md={{span: 12}} sm={{span: 24}} xs={{span: 24}}>
                    <Card className='bg-transparent shadow-c my-5'>
                        <Flex vertical align="center" justify="center" gap={15}>
                            <motion.div
                                initial={{ y: '-100%', opacity: 0 }}
                                whileInView={{
                                    opacity: 1,
                                    y: 0,
                                }}
                                transition={{ delay: .1, duration: 1, }}
                                viewport={{once: true}}>
                                <Image
                                    src={"/assets/images/logo.png"}
                                    alt='mozeef'
                                    preview= {false}
                                    width={'100px'}
                                />
                            </motion.div>
                            <Flex vertical gap={3} align='center'>
                                <motion.div
                                    initial={{ y: '-100%', opacity: 0 }}
                                    whileInView={{
                                        opacity: 1,
                                        y: 0,
                                    }}
                                    transition={{ delay: .2, duration: 1, }}
                                    viewport={{once: true}}>
                                    <Title 
                                        level={3} 
                                        className="brown-gadient m-0"
                                        >
                                        Welcome to Nextdoor Pros
                                    </Title>
                                </motion.div>
                                <motion.div
                                    initial={{ y: '-100%', opacity: 0 }}
                                    whileInView={{
                                        opacity: 1,
                                        y: 0,
                                    }}
                                    transition={{ delay: .2, duration: 1, }}
                                    viewport={{once: true}}>
                                    <Text 
                                        level={5} 
                                        className="text-gray"
                                        >
                                        Please <strong>sign in</strong> to enter credentials
                                    </Text>
                                </motion.div>
                            </Flex>
                        </Flex>
                        <motion.div
                            initial={{ y: '100%', opacity: 0 }}
                            whileInView={{
                                opacity: 1,
                                y: 0,
                            }}
                            transition={{ delay: .3, duration: 1, }}
                            viewport={{once: true}}
                        >
                            <Form 
                                form={form}
                                layout='vertical'
                                requiredMark={false}
                                className='mt-3'
                            >
                                <Row gutter={[16, 16]}>
                                
                                <Col span={24}>
                                        <MyInput 
                                            label='New Password'
                                            name='newpassword'
                                            required
                                            message='Please enter new password'
                                            placeholder=''
                                        />
                                    </Col>
                                    <Col span={24}>
                                        <MyInput 
                                            label='Confirm Password'
                                            name='confirmpassword'
                                            required
                                            message='Please enter confirm password'
                                            placeholder=''
                                        />
                                    </Col>
                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <Button className="btn rounded mt-2" block>Submit</Button>
                                    </Col>
                                </Row>
                            </Form>
                        </motion.div>
                    </Card>  
                </Col>
            </Row>
        </div>
    </div>
  )
}

export {Changepassword}